import * as React from 'react';

import { UitkButtonSize } from 'uitk-react-button';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkText } from 'uitk-react-text';

import { SecondaryButtonTracked } from 'components/shared';
import { getLinkWithCookies, openOpinionLabPage, trackAnalyticsList } from 'utility';
import { useStores } from 'utility/hooks';

interface OpinionLabButtonProps {
  classes: string;
}

export const OpinionLabButton = ({ classes }: OpinionLabButtonProps) => {
  const { opinionLabStore, analytics, context } = useStores();
  const { label, selectAction } = opinionLabStore;
  const link =
    selectAction.relativeURI &&
    selectAction.relativeURI.value &&
    getLinkWithCookies(selectAction.relativeURI.value, context);

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    trackAnalyticsList(selectAction.analyticsList, analytics);
    openOpinionLabPage(link);
  };

  return (
    <UitkLayoutFlex alignItems="center" direction="column" className={classes} dataTestId="opinion-lab-button">
      <UitkLayoutFlexItem>
        <UitkText size={200} theme="secondary" weight="bold" inline={true}>
          {label}
        </UitkText>
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>
        <span className="all-t-margin-two all-b-margin-three">
          <SecondaryButtonTracked
            text={selectAction.displayAction}
            size={UitkButtonSize.SMALL}
            disabled={false}
            data-test-id="goto-opinion-lab-button"
            aria-label={selectAction.accessibilityMessage}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
          />
        </span>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  );
};
